import React, { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  const completePayment = (data) => {
    setPaymentData(data);
    setPaymentCompleted(true);
    // Store in sessionStorage (clears when tab closes)
    sessionStorage.setItem('paymentCompleted', 'true');
    sessionStorage.setItem('paymentData', JSON.stringify(data));
  };

  const clearPayment = () => {
    setPaymentCompleted(false);
    setPaymentData(null);
    sessionStorage.removeItem('paymentCompleted');
    sessionStorage.removeItem('paymentData');
  };

  return (
    <PaymentContext.Provider 
      value={{ 
        paymentCompleted, 
        paymentData, 
        completePayment, 
        clearPayment 
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => useContext(PaymentContext);